// src/BrowserFullscreenToggle.js (New File)

import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';

// Helper function to handle browser prefix compatibility
const getFullscreenElement = () => {
  return (
    document.fullscreenElement ||
    document.mozFullScreenElement || // Firefox
    document.webkitFullscreenElement || // Chrome, Safari
    document.msFullscreenElement // IE/Edge
  );
};

const BrowserFullscreenToggle = () => {
    // State to track the full-screen status
    const [isFullscreen, setIsFullscreen] = useState(false);

    // 1. Fullscreen Change Listener
    // This effect updates the state when the user uses the ESC key or F11
    useEffect(() => {
        const handleFullscreenChange = () => {
            // Update state based on whether any element is currently fullscreen
            setIsFullscreen(!!getFullscreenElement());
        };

        // Attach listener for the standardized and vendor-prefixed events
        document.addEventListener('fullscreenchange', handleFullscreenChange);
        document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
        document.addEventListener('mozfullscreenchange', handleFullscreenChange);
        document.addEventListener('MSFullscreenChange', handleFullscreenChange);

        return () => {
            // Cleanup: remove listeners when the component unmounts
            document.removeEventListener('fullscreenchange', handleFullscreenChange);
            document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
            document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
            document.removeEventListener('MSFullscreenChange', handleFullscreenChange);
        };
    }, []);

    // 2. Main Toggle Function
    const toggleFullscreen = () => {
        const docEl = document.documentElement;

        if (getFullscreenElement()) {
            // Exit Fullscreen
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
        } else {
            // Enter Fullscreen
            if (docEl.requestFullscreen) {
                docEl.requestFullscreen();
            } else if (docEl.mozRequestFullScreen) {
                docEl.mozRequestFullScreen();
            } else if (docEl.webkitRequestFullscreen) {
                docEl.webkitRequestFullscreen();
            } else if (docEl.msRequestFullscreen) {
                docEl.msRequestFullscreen();
            }
        }
    };

    return (
        <Button 
            onClick={toggleFullscreen}
            variant={isFullscreen ? "warning" : "info"}
        >
            {isFullscreen ? "Exit Fullscreen" : "Browser Fullscreen"}
        </Button>
    );
};

export default BrowserFullscreenToggle;